'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy } from 'react';
import { useBlock } from './hooks/index.js';
import { DEFAULT_BLOCK_ELEMENT } from '../../dom/parseBlockAttributes.js';
const ObjectInspector = lazy(() => import('react-inspector').then(({ ObjectInspector }) => ({ default: ObjectInspector })));
export const DebugBlock = (_a) => {
    var { children, domNode: node = DEFAULT_BLOCK_ELEMENT } = _a, props = __rest(_a, ["children", "domNode"]);
    const { attributes } = useBlock(node);
    return (_jsxs("div", { style: {
            border: '1px solid red',
            padding: '5px 10px',
            marginTop: '10px',
            boxSizing: 'border-box',
        }, children: [_jsx("h2", { children: props.name }), _jsx("div", { style: { padding: '10px' }, children: _jsx(ObjectInspector, { data: props, name: "props", expandLevel: 0 }) }), _jsx("div", { style: { padding: '10px' }, children: _jsx(ObjectInspector, { data: attributes, name: "raw block attributes", expandLevel: 0 }) }), _jsx("div", { style: { padding: '2px', marginTop: '5px' }, children: children })] }));
};
